import { IFlyerDetailPagePosition } from "../../../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";
import { FlyerDetailPagePositionForm } from "./flyer-detail-page-position-form.interface";

export function createFlyerDetailPagePositionForm(
  position: IFlyerDetailPagePosition
): FlyerDetailPagePositionForm {
  return {
    categories: position.categoryDetails || [],
    copies: position.copies,
  };
}
